module.exports = __webpack_public_path__ + "img/c7.9bc8a5df.png";